var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('span',{staticClass:"button pdf",on:{"click":_vm.generatePDF}},[_vm._v("Zusammenfassung als PDF")])])
}
var staticRenderFns = []

export { render, staticRenderFns }